module.exports = __webpack_public_path__ + "f96b8fe4ea72298984300ba274547db9.svg";